"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Cell = Cell;
exports.Header = Header;
exports.HeaderCell = HeaderCell;
exports.Main = Main;
exports.Row = Row;
exports.Table = Table;
var _react = _interopRequireDefault(require("react"));
var _styled = require("./styled");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
//
// Main component
// -------------------------------------------------------------------------------------------------

/**
 * The `Table` component helps displays _tabular_ data.
 *
 * @alpha
 */
function Table({
  children,
  css,
  testId
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledTable, {
    css: css,
    "data-testid": testId
  }, children);
}

//
// Sub-components
// -------------------------------------------------------------------------------------------------

Table.Cell = Cell;
function Cell({
  children,
  columns,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledTD, _extends({
    colSpan: columns
  }, props), /*#__PURE__*/_react.default.createElement("div", null, children));
}
Table.Header = Header;
function Header({
  children,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledTHead, props, /*#__PURE__*/_react.default.createElement("tr", null, children));
}
Table.HeaderCell = HeaderCell;
function HeaderCell({
  children,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledTH, props, children);
}
Table.Main = Main;
function Main({
  children,
  testId,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledTBody, _extends({
    "data-testid": testId
  }, props), children);
}
Table.Row = Row;
function Row({
  bg,
  children,
  onClick,
  ...props
}) {
  return /*#__PURE__*/_react.default.createElement(_styled.StyledTR, _extends({
    bg: bg,
    onClick: onClick
  }, props), children);
}